import { getLogger, setLevel, getLevel, setStreams } from "@mm/log";

import React from "react";
import ReactDOM from "react-dom";

import topic from "pubsub-js";
import DebugDisplay from "./DebugDisplay";

import AppTheme from "../theme/AppTheme";

const LOGGER = "frontend/DebugLogger";

function SimpleLogger(cb) {
    console.log("Init dumper");
    this.cb = cb;
}

SimpleLogger.prototype.write = function(rec) {
    this.cb(rec);
};


function registerLogger() {
    try {
        const level = getLevel();
        if(!level) {
            setLevel("INFO");
        }

        const mainlog = getLogger();
        console.log("REGISTERING to mainLog", mainlog);
        const ourtopic = "frontend/debuglog";
        const publish = (rec) => {
            topic.publish(ourtopic, rec);
        };
        const streams = mainlog.streams || [];
        streams.push({
            type: "raw",
            stream: new SimpleLogger(publish)
        });
        setStreams(streams);

        ReactDOM.render(
            <AppTheme>
                <DebugDisplay topicname={ ourtopic } />
            </AppTheme>,
            document.getElementById("debuglog"),
            () => {
                const {
                    navigator: {
                        appCodeName,
                        appName,
                        appVersion,
                        cookieEnabled,
                        language,
                        onLine,
                        platform,
                        product,
                        userAgent
                    }
                } = window;
                const log = {
                    navigator: {
                        appCodeName,
                        appName,
                        appVersion,
                        cookieEnabled,
                        language,
                        onLine,
                        platform,
                        product,
                        userAgent
                    }
                };
                getLogger(LOGGER).error(log, "Started debug logging");
            }
        );
    } catch(err) {
        console.log("Failed to load debug listener", err);
    }
}

function keydownStarter(ev) {
    this.pressed = this.pressed || {};
    if (ev.type == "keydown") {
        if ("deb".indexOf(ev.key) > -1) {
            this.pressed[ev.key] = true;
        }
    }
    if (ev.type == "keyup") {
        if ("deb".indexOf(ev.key) > -1) {
            this.pressed[ev.key] = false;
        }
    }
    if (this.pressed.d && this.pressed.e && this.pressed.b) {
        registerLogger();
        document.removeEventListener("keydown", keydownStarter );
        document.removeEventListener("keyup", keydownStarter );
    }
}

function registerKeydownStarter() {
    document.addEventListener("keydown", keydownStarter );
    document.addEventListener("keyup", keydownStarter );
}


export { 
    registerLogger,
    registerKeydownStarter,
    keydownStarter
};
